<template>
  <div>
    <AboutBanner v-if="$route.path==='/sub/glass/technical/certificates'" :content="banners.find(item=>item.id === 103).details"
                 :title="banners.find(item=>item.id === 103).title"
                 :img="banners.find(item=>item.id === 103).photo_file"/>
    <about-title title="گواهینامه ها" page-route="/sub/glass/technical/certificates"/>
    <v-container>
      <v-row>
        <v-col v-for="(item,i) in certificates.topics" :key="i" cols="6">
          <block-gallery-item :item="item"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BlockGalleryItem from "../../subNews/gallery/components/GlassGalleryItem";
import AboutTitle from "../../About/Components/AboutTitle";
import {mapState} from "vuex";
import AboutBanner from "../../About/Components/AboutBanner";

export default {
  name: "BlockCertificates",
  components: {AboutBanner, AboutTitle, BlockGalleryItem},
  data() {
    return {
      showImage: '',
      showImageDialog: false,
      galleryItem: [
        {
          id: 1,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 2,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 3,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 4,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },

      ]

    }
  },
  created() {
    if (this.banners==null){
      this.$store.dispatch('glassManagement/getGlassBanners');
    }
    this.$store.dispatch('glassManagement/getGlassCertificates');
  },
  computed: {
    ...mapState({
      certificates: state => state.glassManagement.glassCertificates,
      banners: state => state.glassManagement.glassBanners,
    })
  }
}
</script>

<style scoped>
.date-box {
  padding: 0 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}

.g-box:hover > * > * > .date-box {
  background-color: #0846be;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}

.date-box > * {
  color: white;
  font-size: 16px !important;
}
</style>